import { render, staticRenderFns } from "./orderSelect.vue?vue&type=template&id=3bc47c5d&scoped=true"
import script from "./orderSelect.vue?vue&type=script&lang=js"
export * from "./orderSelect.vue?vue&type=script&lang=js"
import style0 from "./orderSelect.vue?vue&type=style&index=0&id=3bc47c5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc47c5d",
  null
  
)

export default component.exports